import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";

import Img from "gatsby-image";
import Theme from "../../../../vars/ThemeOptions";
import { P, Button } from "../../../common";

const sectionMaxHeight = "30rem";

const WrapRow = styled(Row)`
  //margin-top: 2rem;
  margin-bottom: 4rem;
  margin-right: 0px;
  margin-left: 0px;
  max-height: ${sectionMaxHeight};
  height: 100%;
  .image-col {
    padding-left: 0px;
    padding-right: 0px;
    height: ${sectionMaxHeight};
    overflow: hidden;
    max-height: ${sectionMaxHeight};
    .gatsby-image-wrapper {
      height: 100%;
    }
  }
  .content-col {
    background: ${Theme.hex("blue")};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .content-div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 2rem;
      .copy {
        margin-bottom: 2rem;
      }
    }
  }
  @media only screen and (max-width: 767px) {
    .image-col {
      max-height: 15rem;
      overflow: hidden;
    }
  }
`;

export const HomeHero = ({ link, parentSlug }) => {
  // console.log("link: ", link)
  const { displayTitle, coverImage, entry, subtext } = link;
  const { slug } = entry;
  //const { fixed } = coverImage ? coverImage : null;
  const { fluid } = coverImage ? coverImage : null;
  return (
    <WrapRow>
      <Col sm={12} md={7} className="image-col">
        {fluid && <Img fluid={fluid} alt={coverImage.title} />}
      </Col>
      <Col sm={12} md={5} className="content-col">
        <div className="content-div">
          {displayTitle && (
            <h3 style={{ textAlign: "center", color: "white" }}>
              {slug === "explore-our-social-purpose-report" ? (
                <div>
                  Texas Health Resources
                  <br />
                  Social Purpose Report
                </div>
              ) : (
                displayTitle
              )}
            </h3>
          )}
          {subtext && (
            <P className="copy" white>
              {subtext.subtext}
            </P>
          )}
          {slug && !parentSlug === "home" ? (
            <Button white to={"/" + slug}>
              Learn More
            </Button>
          ) : null}
        </div>
      </Col>
    </WrapRow>
  );
};
